import { createContext } from 'react';
import PropTypes from 'prop-types';

const HookFormStepContext = createContext();

const HookFormStepProvider = ({
  stepTitle,
  hasNav = true,
  onSubmit,
  navigate,
  reachedStep,
  children,
}) => (
  <HookFormStepContext.Provider
    value={{
      stepTitle,
      hasNav,
      onSubmit,
      navigate,
      reachedStep,
    }}>
    {children}
  </HookFormStepContext.Provider>
);

HookFormStepProvider.propTypes = {
  stepTitle: PropTypes.string.isRequired,
  hasNav: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  navigate: PropTypes.func,
  reachedStep: PropTypes.number,
  children: PropTypes.object.isRequired,
};

export { HookFormStepContext, HookFormStepProvider };
